module.exports = __webpack_public_path__ + "media/images/Sink Install with laser-01039cd3.jpg";